import React from "react";
import { Box, Typography, Stack } from "@mui/material";

const ContactInfo = () => {
  return (
    <div className="base">
      <Typography textAlign="left">KONTAKT</Typography>
      <Stack
        direction="row"
        sx={{
          justifyContent: "space-between",
          flexWrap: "wrap",
        }}
      >
        <Stack paddingBottom={"16px"}>
          <Stack
            direction="row"
            sx={{
              flexWrap: "wrap",
            }}
          >
            <Stack>
              <Typography textAlign="left" paddingRight={"80px"}>
                Adres:
              </Typography>
            </Stack>
            <Stack>
              <Typography textAlign="left">ul. Stefana Żeromskiego 94B</Typography>
              <Typography textAlign="left">90-550 Łódź</Typography>
            </Stack>
          </Stack>
          <Stack paddingTop={"16px"}>
            <Typography textAlign="left">Farid Agajew</Typography>
          </Stack>
          <Stack
            direction="row"
            sx={{
              flexWrap: "wrap",
            }}
          >
            <Stack>
              <Typography textAlign="left" paddingRight={"70px"}>
                Telefon:
              </Typography>
              <Typography textAlign="left" paddingRight={"70px"}>
                Email:
              </Typography>
            </Stack>
            <Stack>
              <Typography textAlign="left">+48 698 002 363</Typography>
              <Typography textAlign="left">farid.aghayev@wp.pl</Typography>
            </Stack>
          </Stack>
          <Box paddingTop={"16px"}>
            <Typography textAlign="left">Paweł Marjański</Typography>
          </Box>
          <Stack
            direction="row"
            sx={{
              flexWrap: "wrap",
            }}
          >
            <Stack>
              <Typography textAlign="left" paddingRight={"70px"}>
                Telefon:
              </Typography>
              <Typography textAlign="left" paddingRight={"70px"}>
                Email:
              </Typography>
            </Stack>
            <Stack>
              <Typography textAlign="left">+48 531 199 469</Typography>
              <Typography textAlign="left">pm@marjanscy.pl</Typography>
            </Stack>
          </Stack>

          {/* <Box paddingTop={"16px"}>
            <Typography textAlign="left">Sima Marjańska</Typography>
          </Box>
          <Stack
            direction="row"
            sx={{
              flexWrap: "wrap",
            }}
          >
            <Stack>
              <Typography textAlign="left" paddingRight={"70px"}>
                Telefon:
              </Typography>
              <Typography textAlign="left" paddingRight={"70px"}>
                Email:
              </Typography>
            </Stack>
            <Stack>
              <Typography textAlign="left">+48 694 558 817</Typography>
              <Typography textAlign="left">sm@marjanscy.pl</Typography>
            </Stack>
          </Stack> */}
        </Stack>
        <Stack paddingBottom={"16px"}>
          <Typography textAlign="left">
            AGHAYEV PRACOWNIA PROJEKTOWA FARID AGAJEW
          </Typography>
          <Typography textAlign="left">
            90-550 Łódź ul. Stefana Żeromskiego 94B
          </Typography>
          <Typography textAlign="left">NIP: 7251485671</Typography>
          <Typography textAlign="left" marginBottom={"13%"}>
            REGON: 473276922
          </Typography>
          <Typography textAlign="left">
            MARJAŃSCY PRACOWNIA PROJEKTOWA Paweł Marjański
          </Typography>
          <Typography textAlign="left">
            91-078 Łódź ul. Kasprzaka 59 m.36
          </Typography>
          <Typography textAlign="left">NIP: 7272860938</Typography>
          <Typography textAlign="left">Regon: 522640511</Typography>
        </Stack>
        <Stack paddingBottom={"16px"}>
          <iframe
            className="map"
            title="Aghayev Marjańscy Pracownia Projektowa"
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2929.374945676666!2d19.4488864!3d51.7595536!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x471bcb49ccca400b%3A0x849d73f48c6e2479!2sAghayev%20Marja%C5%84scy%20Pracownia%20Projektowa!5e1!3m2!1spl!2spl!4v1775217612094!5m2!1spl!2spl"
            height="100%"
            width="height"
            style={{ border: "0" }}
            allowFullScreen=""
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
          ></iframe>
        </Stack>
      </Stack>
    </div>
  );
};

export default ContactInfo;
